import React from 'react'

import lang from '@/lang'
import { SubscriptionTypeTypes } from '@/modules/base/util/constants'
import SubscriptionService from '@/modules/base/components/subscription/subscriptionService'
import { updateSubscriptionDetails } from '@/redux/ducks/subscription/details'
import { toast } from '@/modules/base/components/toast/toastConfig'
import { isMeinBuero } from '@/utils/build-env'
import TrialModalMbo from '@/modules/base/components/modal/trial-modal/trial-modal-mbo'
import TrialModalOmo from '@/modules/base/components/modal/trial-modal/trial-modal-omo'
import { TrialModalProps } from '@/modules/base/components/modal/trial-modal/trial-modal-props'
import GtmService, { GtmEventTypes } from '@/modules/_services/gtm.service'

type StartTrialModalProps = {
  open: boolean
  productType: keyof typeof SubscriptionTypeTypes
  dataQsId: string
  onClose: () => void
  onSuccess?: () => void
}

const isMB = isMeinBuero()

const StartTrialModal = (props: StartTrialModalProps) => {
  const { productType, onClose, onSuccess } = props

  const startTrial = async(): Promise<void> => {
    try {
      await SubscriptionService.createTrials([productType])
      if (!isMB) {
        GtmService.pushEvent({
          event: GtmEventTypes.GaEventHub,
          eventCategory: lang.myAccount.subscriptionUpgrade.documentTrialModal.eventCategory,
          eventAction: lang.continueButtonLabel,
          eventLabel: lang.myAccount.subscriptionUpgrade.documentTrialModal.eventLabel(productType),
        })
      }
      if (window.pendo && isMB) {
        window.pendo.track('trialStarted', {
          productType,
        })
      }

      if (!isMB) {
        await updateSubscriptionDetails(true, true)
      }
      onSuccess?.()
    } catch {
      toast.showToast({ type: 'error', message: lang.defaultErrorMessage })
    } finally {
      onClose()
    }
  }

  const trialProps: TrialModalProps = { ...props, onStartTrial: startTrial }
  return (
    isMeinBuero()
      ? <TrialModalMbo {...trialProps} />
      : <TrialModalOmo {...trialProps} />
  )

}

export default StartTrialModal
